
<div class="role-edit-json">
  <div class="modal role-edit-json-modal">
    <div class="modal-background" @click="closeModal" />
    <button class="modal-close is-large" @click="closeModal" />

    <div v-if="r" class="modal-card">
      <section class="modal-card-body">
        <span v-if="superuser" class="button is-danger is-small is-rounded"
          style="position:absolute; right:20px; top:10px; padding:5px 10px;" @click="preDeleteRole">
          <i class="fa fa-bomb" />&nbsp;Delete Role
        </span>
        <p class="subtitle is-4 has-text-grey" style="margin-bottom:8px">Edit Role JSON</p>
        <p class="has-text-weight-medium">{{ r.business.name }} - {{ r.workflow_name }} - {{ r.role_name }}</p>

        <div class="field">
          <div class="control">
            <textarea class="textarea is-info has-text-weight-medium" style="color:white; background-color:slategrey"
              :style="jsonStyle" v-model="dataJSON" placeholder="Data JSON" rows="20"></textarea>
          </div>
        </div>

        <div class="field has-addons">
          <p class="control">
            <button class="button is-medium is-warning" :class="{ 'is-danger': invalidJSON }" @click="parseJSON">
              <span class="icon">
                <i class="fa fa-pencil-alt" />&nbsp;&nbsp;
              </span>Parse
            </button>
          </p>
          <p class="control is-expanded">
            <button class="button is-success is-fullwidth is-medium" @click="submit">Update</button>
          </p>
        </div>
      </section>
    </div>
  </div>
</div>
